import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const bingDesktopTextRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'bing_text_mobile',
  className: 'bing_text_mobile',
  type: 'BingTextMobile',
  associationType: 'BingTextMobile',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Bing search ad'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showMultipleLineLongHeadline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
    showAdsLabelInlineWithDescription: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    placementContainer: {
      border: '5px solid #605e5c',
      position: 'relative',
      borderBottom: 'none',
      borderRadius: '40px 40px 0 0',
      width: 700,
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
      maxHeight: 16,
    },
    cardParent: {
      margin: '45px 15px 0 15px',
      borderBottom: 'none',
      borderRadius: 0,
      paddingBottom: 1,
      '&:before': {
        top: 20,
        left: '50%',
        border: '5px solid #605e5c',
        content: '""',
        position: 'absolute',
        borderRadius: 5,
      },
    },
    previewContent: {
      border: '0.5px solid #ddd',
      width: 608,
      height: 110,
      padding: '8px 16px',
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '24px',
      height: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
    },
    description: {
      color: '#333',
      fontSize: '13px',
      display: 'inline-block',
      flexGrow: 1,
    },
    descriptionParent: {
      display: 'flex',
    },
  },
};

export default bingDesktopTextRaw;
